module.exports = __webpack_public_path__ + "img/0xf853a98ac55a756ae42379a312d55ddfdf7c8514.bb72e7e4.png";